module.exports = __webpack_public_path__ + "static/media/Camera02.fb433fdc.jpg";